import { render, staticRenderFns } from "./SuiviFacturationGlobal.vue?vue&type=template&id=dc2b9108&"
import script from "./SuiviFacturationGlobal.vue?vue&type=script&lang=js&"
export * from "./SuiviFacturationGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports